import { ITheme } from 'contexts/theme'

export const conduccoThemeSetup: ITheme = {
  main: '#3024E1',
  light: '#F0F0F0',
  dark: '#1A147C',
  bg: {
    main: '#31F7FF',
    light: '#97B8EF',
    dark: '#29B6DA',
  },
  info: {
    main: '#3024E1',
    light: '#362bdd',
    dark: '#231AA1',
  },
}

export const ritaRHThemeSetup: ITheme = {
  main: '#6816B0',
  dark: '#5C17A2',
  light: '#9900e6',
  bg: {
    main: '#CC00FF',
    light: '#a300cc',
    dark: '#660080',
  },
  info: {
    main: '#6816B0',
    light: '#8c00d2',
    dark: '#5C17A2',
  },
}
